import { LoginCallback as OktaLoginCallback, useOktaAuth } from '@okta/okta-react';
import { Link } from 'react-router-dom';

const CustomCallbackError = ({ error }: { error: Error }) => {
  return (
    <div className="card">
      <p className="error">{error.toString()}</p>
      <Link to="/login" className="primary-button" style={{ display: 'inline-block', textDecoration: 'none' }}>
        Return to sign in
      </Link>
    </div>
  );
};

export const LoginCallback = () => {
  const { authState } = useOktaAuth();
  const hasError = !!authState?.error;

  return (
    <div className="centered full-height">
      {!hasError ? (
        <>
          <div className="spinner" />
          <p className="muted">Completing sign in...</p>
        </>
      ) : null}
      <OktaLoginCallback loadingElement={<></>} errorComponent={CustomCallbackError} />
    </div>
  );
};
